const GALLONS_PER_LITER = 0.264172;

/**
 * Converts volume from liters to gallons, rounded to two decimal places.
 */
export function litersToGallons(liters: number): number {
    return Math.round(liters * GALLONS_PER_LITER * 100) / 100;
}
